import templateUrl from './password-strength.component.html';

export const PasswordStrengthComponent = {
    templateUrl,
    bindings: {
        password: "<",
        confirmPassword: "<",
        passwordValidator: "<"
    },
    controller: class PasswordStrengthComponent {
        constructor($attrs) {
            'ngInject';
            this.$attrs = $attrs;
        }

        $onChanges() {
            if (!this.passwordValidator) {
                this.requiredValidationRules = [];
                return;
            }

            this.requiredValidationRules = this.passwordValidator.validationRules
                .filter(p => p.isRequired())
                .map(rule => ({
                    description: rule.description,
                    isSatisfied: rule.isSatisfiedBy(this.password || "")
                }));
            let isValid = this.passwordValidator.validate(this.password);

            // Optionally verify the confirmation field matches, when the consumer supplies one.
            if ("confirmPassword" in this.$attrs) {
                const passwordsMatch = !!this.password && this.password === this.confirmPassword;
                this.requiredValidationRules.push({
                    description: "Password and confirmation match",
                    isSatisfied: passwordsMatch
                });
                isValid = isValid && passwordsMatch;
            }

            this.passwordStrength = this.passwordValidator.calculateStrength(this.password) * 100;
            this.isValid = isValid;
        }
    }
}
